import React, { useEffect, useRef } from "react";

const Tooltip = ({ content, children }) => {
  const tooltipRef = useRef(null);

  useEffect(() => {
    const el = tooltipRef.current;
    if (!el) return;

    const wheelHandler = (e) => {
      e.preventDefault();
      e.stopPropagation();
      el.scrollLeft += e.deltaY;
    };

    el.addEventListener("wheel", wheelHandler, { passive: false });

    return () => {
      el.removeEventListener("wheel", wheelHandler);
    };
  }, []);

  if (!content) return children;

  return (
    <span className="sad-tooltip-wrap">
      {children}
      <span ref={tooltipRef} className="sad-tooltip">
        {content}
      </span>
    </span>
  );
};

export default Tooltip;
